import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaskPipe } from './mask.pipe';

@NgModule({
  declarations: [MaskPipe],
  imports: [CommonModule],
  exports: [MaskPipe]
})
export class MaskModule {}
